module.exports = __webpack_public_path__ + "img/solution_office_sys.240dd97d.jpg";